/** @jsx jsx */
import React, { useState } from "react"
import { graphql } from "gatsby"
import { jsx, Button, Text, Box, Flex } from "theme-ui"
import queryString from "query-string"
import Icon from "./Icon"
import Modal from "./Modal"
import Form from "./form"
import Link from "./Link"
import HubspotFormModal from "./HubspotFormModal"
import theme from "../../gatsby-plugin-theme-ui/index"

export const query = graphql`
  fragment ActionFragment on ContentfulAction {
    contentful_id
    id
    label
    style
    icon
    iconSize
    classnameForAnalytics
    classname
    url
    __typename
    actionEvent
    form {
      ...FormFragment
    }
    hubspotForm {
      formId
      portalId
      region
      classname
    }
  }
`

const Action = ({
  icon,
  label,
  style,
  url,
  actionEvent = "link",
  width,
  form,
  hubspotForm = {},
  iconSize,
  iconColor,
  onFinish,
  fontColor,
  wordWrap,
  mFontsize,
  fontsize,
  fontWeight,
  borderCustom,
  paddingCustom,
  secondaryIconcolor,
  footer,
  classname,
  classnameForAnalytics,
  ...props
}) => {
  let queryParams = ""

  if (typeof window !== "undefined") {
    queryParams = queryString.parse(window.location.search)
  }
  const { banner } = queryParams
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const styleMap = {
    link: "link",
    "link underline": "linkUnderline",
    "link large": "linkLarge",
    "link pink": "linkPink",
    "linkv2 grey": "linkV2",
    "button primary": "primary",
    "button primaryv2": "primaryV2",
    "button primaryaltv2": "primaryAltV2",
    "button primary large": "primaryLarge",
    "button secondary": "secondary",
    "button secondaryv2": "secondaryV2",
    hoveronorange: "pinkHover",
    linkprimary: "linkPrimary",
  }
  const actionType = (style?.styles ?? style)?.trim().toLowerCase()
  const variant = actionType && styleMap[actionType] ? styleMap[actionType] : "link"
  const buttonPadding = !label ? "0" : Array.isArray(paddingCustom) ? paddingCustom : paddingCustom ?? "5px 20px"

  return (
    <>
      {actionEvent === "link" && (
        <Link
          to={banner ? `${url}?banner=${banner}` : url}
          style={{ minWidth: "fit-content", width }}
          className={classname}
          classnameForAnalytics={`action-link ${classnameForAnalytics}`}
        >
          <Flex sx={{ width: "100%", justifyContent: "space-between", alignItems: "center" }} className="action_btn">
            <Button
              {...props}
              variant={variant}
              onClick={() => {
                return onFinish && onFinish()
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: buttonPadding,
                border: `${borderCustom ?? theme.buttons[variant]?.border ?? 0}`,
                width: [width || "max-content"],
                "&:hover": {
                  cursor: "pointer",
                },
              }}
              className={classnameForAnalytics}
            >
              {icon && (
                <Icon
                  icon={icon}
                  className="icon"
                  iconSize={iconSize}
                  iconColor={iconColor}
                  sx={{
                    color: iconColor,
                    fontSize: `${iconSize}px`,
                    mr: "5px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                />
              )}
              {label && (
                <Text
                  className={`action_label ${footer && "footerFontFamily"} ${classnameForAnalytics}`}
                  sx={{
                    color: fontColor,
                    wordWrap: wordWrap && "break-word",
                    width: ["100%"],
                    textAlign: ["left", width ? "left" : "center"],
                    fontSize: [mFontsize ?? "14px", fontsize],
                    fontWeight: `${fontWeight ?? "700"}`,
                  }}
                >
                  {label}
                </Text>
              )}
            </Button>
            {variant === "secondaryV2" && (
              <Box className="secondary_btn_container" sx={{ width: "50px" }}>
                <Flex
                  className="secondary_btn_icon"
                  sx={{
                    backgroundColor: secondaryIconcolor || "orangeV2",
                    color: "#fff",
                    borderRadius: "10px",
                    width: "20px",
                    height: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto",
                  }}
                >
                  <Icon icon="bs-arrow-right" iconSize={18} />
                </Flex>
              </Box>
            )}
          </Flex>
        </Link>
      )}
      {actionEvent === "form" && (
        <>
          <Button
            {...props}
            variant={variant}
            onClick={() => {
              openModal()
              const li = onFinish && onFinish()
              return li
            }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: `${borderCustom ?? theme.buttons[variant]?.border ?? 0}`,
              width: [width || "max-content"],
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            {icon && <Icon icon={icon} sx={{ color: iconColor, fontSize: `${iconSize}px`, mr: "5px" }} />}
            {label && (
              <Text
                sx={{ color: fontColor, fontSize: ["14px", fontsize], fontWeight: `${fontWeight ?? "700"}` }}
                className={classnameForAnalytics}
              >
                {label}
              </Text>
            )}
          </Button>
          <Box sx={{ display: "none" }}>
            <Form {...form} />
          </Box>
          <Modal showModal={showModal} closeModal={closeModal}>
            <Form {...form} onFinish={closeModal} isModal={true} />
          </Modal>
        </>
      )}
      {actionEvent === "HubspotForm" && hubspotForm && Object.keys(hubspotForm).length > 0 && (
        <>
          <Button
            {...props}
            variant={variant}
            onClick={() => {
              openModal()
            }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: `${paddingCustom ?? "5px 20px"}`,
              border: `${borderCustom ?? theme.buttons[variant]?.border ?? 0}`,
              width: [width || "max-content"],
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            {icon && <Icon icon={icon} sx={{ color: iconColor, fontSize: `${iconSize}px`, mr: "5px" }} />}
            {label && (
              <Text
                sx={{ color: fontColor, fontSize: ["14px", fontsize], fontWeight: `${fontWeight ?? "700"}` }}
                className={classnameForAnalytics}
              >
                {label}
              </Text>
            )}
          </Button>
          <HubspotFormModal
            showModal={showModal}
            closeModal={closeModal}
            hubspotFormData={hubspotForm}
          ></HubspotFormModal>
        </>
      )}
    </>
  )
}

export default Action
